import { default as ReviewStars } from './review-stars'

export default ReviewStars
